// src/features/engine/toolRegistry.js

import OSRBOITask from "./tools/osrboi/OSRBOITask";
import GRBASTask from "./tools/grbas/GRBASTask";
import BYCETask from "./tools/byce/BYCETask";
import CapeVrAssignmentTask from "./tools/cape-vr/CapeVrAssignmentTask";
import ComposablePerceptualTrialTask from "./tools/composable-perceptual-trial/ComposablePerceptualTrialTask";

const toolRegistry = {
  OSRBOI: OSRBOITask,
  GRBAS: GRBASTask,
  BYCEDevelopment: BYCETask,
  cape_vr: CapeVrAssignmentTask,
  composable_perceptual_trial: ComposablePerceptualTrialTask
  // VAS: VASTask,
  // TWO_AFC: TwoAFC
};

const LEGACY_TOOL_ALIASES = Object.freeze({
  PVQRDevelopment: "BYCEDevelopment",
});

export function resolveToolComponent(tool) {
  const canonicalTool = LEGACY_TOOL_ALIASES[tool] || tool;
  return toolRegistry[canonicalTool] || null;
}

export function resolveAssignmentToolComponent({ session, task } = {}) {
  const authorizedAdapter =
    session?.activityExecutionSnapshot?.runtimeCapability?.frontendAdapter;
  return resolveToolComponent(authorizedAdapter || task?.tool);
}

export default toolRegistry;
